import classnames from 'classnames'
import ReactMarkdown from 'react-markdown'
import { makeRequest } from '../../services/axios'
import styles from './legalPage.module.scss'
import { BlocksRenderer } from '@strapi/blocks-react-renderer'

const Legal = ({ legal }: any) => {
  if (legal) {
    return (
      <main className="p-5">
        <div className={classnames('mt-2 text-center', styles.legalHeader)}>
          <h1>{legal.data?.pageTitle}</h1>
        </div>
        <BlocksRenderer content={legal.data?.content} />;
      </main>
    )
  }
}

export const getStaticPaths = async () => {
  const legalPagesCollection = await makeRequest('get', `/pages`)
  const paths = (Array.isArray(legalPagesCollection) ? legalPagesCollection : []).map((legalPage: any) => ({
    params: { legalPage: String(legalPage.id.toString()) },
  }))

  return { paths, fallback: true }
}

export const getStaticProps = async ({
  params,
}: {
  params: { legalPage: string }
}): Promise<{ props: { legal: any } }> => {
  const legal = await makeRequest('get', `/pages/${params.legalPage}`)
  return {
    props: {
      legal,
    },
  }
}

export default Legal
